import { useSyncExternalStore } from "react";
import { getSessionExpirationState, type SessionExpirationState, subscribeToSessionExpiration } from "./session-expiration";

export function useSessionExpiration(): SessionExpirationState {
  return useSyncExternalStore(subscribeToSessionExpiration, getSessionExpirationState, getSessionExpirationState);
}
